import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";

function ConfirmNewMail(props: any) {
  const navigate = useNavigate();

  useEffect(() => {
    const oldMail = window.location.search.substring(
      window.location.search.indexOf("oldMail=") + 11,
      window.location.search.indexOf("&newMail=")
    );
    const newMail = window.location.search.substring(
      window.location.search.indexOf("newMail=") + 8,
      window.location.search.indexOf("&token=")
    );
    const token = window.location.search.substring(
      window.location.search.indexOf("&token=") + 7
    );

    fetchWrapper
      .post(`${baseUrl}/api/account/ConfirmNewMail`, {
        oldEmail: oldMail,
        newEmail: newMail,
        token: token,
      })
      .then((result) => {
        navigate("/");
      });
  }, []);

  return <div></div>;
}

export default ConfirmNewMail;
